enum EnumUserStatus {
	NotActive = 0,
	Active = 1,
	Dismissed = 2
}
export default EnumUserStatus
